export default __webpack_public_path__ + "static/media/oldfog4.81cb67d9.png";